export var boxSizes = {
  xs: {
    boxSize: 2.5,
    fontSize: 5,
    lineHeight: 2.5,
    paddingHorizontalDense: 0.5,
    paddingHorizontal: 0.75,
    paddingVertical: 0,
    radius: 2.5
  },
  sm: {
    boxSize: 3,
    fontSize: 5,
    lineHeight: 2.5,
    paddingHorizontalDense: 0.5,
    paddingHorizontal: 1,
    paddingVertical: 0.25,
    radius: 3
  },
  md: {
    boxSize: 4,
    fontSize: 4,
    lineHeight: 3,
    paddingHorizontalDense: 1,
    paddingHorizontal: 1.375,
    paddingVertical: 0.5,
    radius: 4
  },
  lg: {
    boxSize: 5,
    fontSize: 3,
    lineHeight: 4,
    paddingHorizontalDense: 1,
    paddingHorizontal: 1.75,
    paddingVertical: 0.5,
    radius: 5
  },
  xl: {
    boxSize: 8,
    fontSize: 1,
    lineHeight: 5,
    paddingHorizontalDense: 2,
    paddingHorizontal: 2.25,
    paddingVertical: 1.5,
    radius: 6
  }
};
export function getBoxSize(size) {
  if (size === void 0) {
    size = 'md';
  }

  return boxSizes[size] || {};
}